/* ============================================================
   LOH Variant State
   Distinguishes three states for the Length pill on a PDP:
     1. Carried + purchasable      -> normal pill, button = (handled by buy-buttons)
     2. Carried + out of stock     -> "Backordered" (variant exists, continue-selling)
     3. NOT carried in this shade  -> distinct disabled pill + clear label,
                                      button = "Not available in this shade"

   Why this exists: Dawn + the theme collapse "sold out" and "this
   colour was never made in this length" into the same struck-through
   pill, so a single-length shade looked perpetually backordered. The
   colour grid already only renders carried colours, so the only
   ambiguous axis is Length.

   Scope guard: only runs on 2-option products (Colour + Length), which
   is every LOH hair-extension line. Anything else is left untouched so
   this can't regress other product types sharing the theme.
   ============================================================ */
(function () {
  'use strict';

  function parseVariants() {
    var el = document.querySelector('script[data-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  function getColorValue(root) {
    var checked = root.querySelector('input[name="Color"]:checked');
    if (checked) return checked.value;
    var sel = root.querySelector('select[name^="options[Color"]');
    if (sel) return sel.value;
    return null;
  }

  // The Length pill is the non-Color radio group inside a pill fieldset.
  function getLengthInputs(root) {
    var inputs = root.querySelectorAll(
      '.product-form__input--pill input[type="radio"]'
    );
    return Array.prototype.filter.call(inputs, function (i) {
      return i.name && i.name !== 'Color';
    });
  }

  // 2-option products: a variant matches if its options array contains
  // both the colour value and the length value (the value spaces are
  // disjoint, so positional mapping isn't needed).
  function findVariant(variants, color, length) {
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      if (opts.indexOf(color) !== -1 && opts.indexOf(length) !== -1) {
        return variants[i];
      }
    }
    return null;
  }

  function classify(variant) {
    if (!variant) return 'not-carried';
    if (variant.available === false) return 'soldout';
    if (
      variant.inventory_management === 'shopify' &&
      typeof variant.inventory_quantity === 'number' &&
      variant.inventory_quantity <= 0
    ) {
      return 'backordered';
    }
    return 'ok';
  }

  function ensureNote(fieldset) {
    var note = fieldset.querySelector('.loh-length-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'loh-length-note';
      note.setAttribute('aria-live', 'polite');
      fieldset.appendChild(note);
    }
    return note;
  }

  function run() {
    var root = document.querySelector('variant-selects');
    if (!root) return;

    var variants = parseVariants();
    if (!variants || !variants.length) return;

    // Scope guard: only 2-option products.
    var sample = variants[0].options || [];
    if (sample.length !== 2) return;

    var color = getColorValue(root);
    if (!color) return;

    var lengthInputs = getLengthInputs(root);
    if (!lengthInputs.length) return;

    var fieldset = lengthInputs[0].closest('.product-form__input--pill');
    var carriedLabels = [];
    var anyNotCarried = false;
    var selectedVariant = null;

    lengthInputs.forEach(function (input) {
      var state = classify(findVariant(variants, color, input.value));
      input.classList.remove(
        'loh-not-carried',
        'loh-soldout',
        'loh-backordered'
      );
      if (state === 'not-carried') {
        input.classList.add('loh-not-carried');
        anyNotCarried = true;
      } else if (state === 'soldout') {
        input.classList.add('loh-soldout');
        carriedLabels.push(input.value);
      } else {
        if (state === 'backordered') input.classList.add('loh-backordered');
        carriedLabels.push(input.value);
      }
      if (input.checked) {
        selectedVariant = findVariant(variants, color, input.value);
      }
    });

    if (fieldset) {
      var note = ensureNote(fieldset);
      if (anyNotCarried && carriedLabels.length) {
        note.textContent =
          'This colour is only available in: ' +
          carriedLabels.join(', ') +
          '.';
        note.hidden = false;
      } else if (anyNotCarried) {
        note.textContent = "This colour isn't available in any length.";
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    // Drive the buy button through buy-buttons' own logic. Passing null
    // (no variant for the selected colour x length) makes it render the
    // "Not available in this shade" state instead of bailing silently.
    var checkedLen = lengthInputs.filter(function (i) {
      return i.checked;
    })[0];
    if (checkedLen) {
      if (!selectedVariant) {
        // Neutralise the hidden id so the form can't submit a wrong
        // variant and so buy-buttons' poll converges on the no-variant
        // branch regardless of how the picker handles a dead combo.
        var idInput = document.querySelector('input.product-variant-id');
        if (idInput && idInput.value !== '') idInput.value = '';
      }
      if (typeof window.__lohUpdateUIForVariant === 'function') {
        window.__lohUpdateUIForVariant(
          selectedVariant ? selectedVariant.id : null
        );
      }
    }
  }

  function bind() {
    // The picker snippet renders in more than one form on the page, so
    // this asset can be included twice. Bind listeners only once.
    if (window.__lohVariantStateBound) return;
    window.__lohVariantStateBound = true;
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'Color' || e.target.name)) {
        // Recompute on any option change; cheap and keeps state honest.
        run();
      }
    });
    // buy-buttons exposes its updater on DOMContentLoaded; re-run then.
    document.addEventListener('DOMContentLoaded', run);
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
